/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiListSelectorType } from './InternalApiListSelectorType';
import {
    InternalApiListSelectorTypeFromJSON,
    InternalApiListSelectorTypeFromJSONTyped,
    InternalApiListSelectorTypeToJSON,
    InternalApiListSelectorTypeToJSONTyped,
} from './InternalApiListSelectorType';
import type { InternalApiListSelectorOption } from './InternalApiListSelectorOption';
import {
    InternalApiListSelectorOptionFromJSON,
    InternalApiListSelectorOptionFromJSONTyped,
    InternalApiListSelectorOptionToJSON,
    InternalApiListSelectorOptionToJSONTyped,
} from './InternalApiListSelectorOption';

/**
 * 
 * @export
 * @interface InternalApiListSelector
 */
export interface InternalApiListSelector {
    /**
     * 
     * @type {string}
     * @memberof InternalApiListSelector
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiListSelector
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiListSelector
     */
    customListId: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiListSelector
     */
    expression: string;
    /**
     * 
     * @type {InternalApiListSelectorType}
     * @memberof InternalApiListSelector
     */
    selectorType: InternalApiListSelectorType;
    /**
     * 
     * @type {Array<InternalApiListSelectorOption>}
     * @memberof InternalApiListSelector
     */
    options: Array<InternalApiListSelectorOption>;
}



/**
 * Check if a given object implements the InternalApiListSelector interface.
 */
export function instanceOfInternalApiListSelector(value: object): value is InternalApiListSelector {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('customListId' in value) || value['customListId'] === undefined) return false;
    if (!('expression' in value) || value['expression'] === undefined) return false;
    if (!('selectorType' in value) || value['selectorType'] === undefined) return false;
    if (!('options' in value) || value['options'] === undefined) return false;
    return true;
}

export function InternalApiListSelectorFromJSON(json: any): InternalApiListSelector {
    return InternalApiListSelectorFromJSONTyped(json, false);
}

export function InternalApiListSelectorFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiListSelector {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'code': json['code'],
        'customListId': json['customListId'],
        'expression': json['expression'],
        'selectorType': InternalApiListSelectorTypeFromJSON(json['selectorType']),
        'options': ((json['options'] as Array<any>).map(InternalApiListSelectorOptionFromJSON)),
    };
}

export function InternalApiListSelectorToJSON(json: any): InternalApiListSelector {
    return InternalApiListSelectorToJSONTyped(json, false);
}

export function InternalApiListSelectorToJSONTyped(value?: InternalApiListSelector | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'code': value['code'],
        'customListId': value['customListId'],
        'expression': value['expression'],
        'selectorType': InternalApiListSelectorTypeToJSON(value['selectorType']),
        'options': ((value['options'] as Array<any>).map(InternalApiListSelectorOptionToJSON)),
    };
}

